<style lang="sass" scoped>
@import "../../../../../css/core";

.-short, .-long {
  text-align: center;
}

.-short-available {
  color: $color-blue;
}

.-long-available {
  color: $color-blue;
}

.-shortage {
  background-color: $color-red;
}
</style>


<template>
<div class="reservations-table-availabilities-body">
  <div class="-row" v-bind:style="rowStyle">
    <div v-for="a in _availabilities"
         class="-cell"
         v-bind:class="{'-shortage': a.capaOver}"
         v-bind:style="cellStyleByTick(a.tick, a.capaOver)"
         @mouseover="$dispatch('tick-over', a.tick)"
         @mouseout="$dispatch('tick-out', a.tick)"
    >
      <div
          class="-short"
          v-bind:class="{'-short-available': a.short}"
          v-bind:style="bitStyle">{{ a.short ? '●' : '' }}</div>
      <div
          class="-long"
          v-bind:class="{'-long-available': a.long}"
          v-bind:style="bitStyle">{{ a.long ? '○' : '' }}</div>
    </div>
  </div>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'reservations-table-availabilities-body',
  mixins: [require('../body.vue')],
  props: {
    resourceSequence: {
      type: Array,
      required: true,
    },
    availabilities: {
      type: Array,
      required: true,
    },
  },
  computed: {
    _availabilities () {
      return this.resourceSequence.map((resource, i) => {
        const tmp = this.availabilities.find(x => resource.tick.isSame(x.datetime))
        return {
          tick: resource.tick,
          short: tmp ? tmp.short : false,
          long: tmp ? tmp.long : false,
          capaOver: tmp ? tmp.capaOver : false,
          staffShortage: resource.staffRemains < 0,
          shampooSinkShortage: resource.shampooSinkRemains < 0,
        }
      })
    },
    bitStyle() {
      return {
        width: this.cellStyle.width,
        height: `calc(${this.cellStyle.height} / 2)`,
        'line-height': `calc(${this.cellStyle.height} / 2)`,
      }
    },
  },
  methods: {
    isAvailableForShortMenu(seq) {
      if (seq.length < 6) {
        return false
      }
      return seq[0].staffRemains > 0 && seq[1].staffRemains > 0
          && seq[4].staffRemains > 0 && seq[5].staffRemains > 0
          && seq[4].shampooSinkRemains > 0 && seq[5].shampooSinkRemains > 0
    },
    isAvailableForLongMenu(seq) {
      if (seq.length < 7) {
        return false
      }
      return seq[0].staffRemains > 0 && seq[1].staffRemains > 0 && seq[2].staffRemains > 0
          && seq[5].staffRemains > 0 && seq[6].staffRemains > 0
          && seq[5].shampooSinkRemains > 0 &&  seq[6].shampooSinkRemains > 0
    },
    cellStyleByTick(tick, shortage=false) {
      let style = this._cellStyleByTick(tick)

      if (tick.isSame(this.tick)) {
        if (shortage) {
          style['background'] = this.backgroundColorFocusedError
        } else {
          style['background'] = this.backgroundColorFocused
        }
      }
      return style
    },
  }
}
</script>



// WEBPACK FOOTER //
// body.vue?156f37ee